/**
 * Environment Configuration
 * Runtime environment variables and settings
 */

// Environment types
export type NodeEnv = "development" | "production" | "test";

// Environment Variables
export const ENV = {
  NODE_ENV: (process.env.NODE_ENV as NodeEnv) || "development",
  API_URL: process.env.NEXT_PUBLIC_API_URL || "http://127.0.0.1:8000",
  API_TIMEOUT: parseInt(process.env.NEXT_PUBLIC_API_TIMEOUT || "10000", 10),
} as const;

// Environment utilities
export const isDevelopment = (): boolean => ENV.NODE_ENV === "development";
export const isProduction = (): boolean => ENV.NODE_ENV === "production";
export const isTest = (): boolean => ENV.NODE_ENV === "test";
